import { type ReactElement } from 'react'
import { useStep } from '.'

type StepProps = {
  index: number
  children: ReactElement
}

export const Step = ({ index, children }: StepProps) => {
  const { step } = useStep()

  if (step !== index) {
    return null
  }

  return children
}
